module.exports = __webpack_public_path__ + "2b287ef72715018f7e9c0e42a98abf03.png";